import type { StatusTone } from '@/lib/status';

/**
 * Props for a status pill.
 *
 * @since 1.0.0
 */
export interface StatusPillProps {
    tone: StatusTone;
    label: string;
}

/**
 * The uppercase mono badge used wherever a row needs a one-word verdict.
 *
 * @since 1.0.0
 * @param props - the tone to render and the wording to show
 * @returns the pill element
 */
export function StatusPill({ tone, label }: StatusPillProps) {
    return <span className={`fkwd-pill fkwd-pill--${tone}`}>{label}</span>;
}
